export const COUNTRIES_BY_CODE = {
	"US": {
		"iso_code": "US",
		"code": "US",
		"name": "United States",
		"currency": "USD",
	},
	"UK": {
		"iso_code": "GB",
		"code": "UK",
		"name": "United Kingdom",
		"currency": "GBP",
	},
	"CA": {
		"iso_code": "CA",
		"code": "CA",
		"name": "Canada",
		"currency": "CAD",
	},
	"AS": {
		"iso_code": "AU",
		"code": "AS",
		"name": "Australia",
		"currency": "AUD",
	},
	"SN": {
		"iso_code": "SG",
		"code": "SN",
		"name": "Singapore",
		"currency": "SGD",
	},
	"EI": {
		"iso_code": "IE",
		"code": "EI",
		"name": "Ireland",
		"currency": "EUR",
	},
	"NZ": {
		"iso_code": "NZ",
		"code": "NZ",
		"name": "New Zealand",
		"currency": "NZD",
	},
	"RP": {
		"iso_code": "PH",
		"code": "RP",
		"name": "Philippines",
	},
	"SW": {
		"iso_code": "SE",
		"code": "SW",
		"name": "Sweden",
		"currency": "SEK",
	},
	"FI": {
		"iso_code": "FI",
		"code": "FI",
		"name": "Finland",
		"currency": "EUR",
	},
	"AF": {
		"iso_code": "AF",
		"code": "AF",
		"name": "Afghanistan",
	},
	"AL": {
		"iso_code": "AL",
		"code": "AL",
		"name": "Albania",
	},
	"AG": {
		"iso_code": "DZ",
		"code": "AG",
		"name": "Algeria",
	},
	"AN": {
		"iso_code": "AD",
		"code": "AN",
		"name": "Andorra",
	},
	"AO": {
		"iso_code": "AO",
		"code": "AO",
		"name": "Angola",
	},
	"AV": {
		"iso_code": "AI",
		"code": "AV",
		"name": "Anguilla",
	},
	"AC": {
		"iso_code": "AG",
		"code": "AC",
		"name": "Antigua and Barbuda",
	},
	"AR": {
		"iso_code": "AR",
		"code": "AR",
		"name": "Argentina",
	},
	"AM": {
		"iso_code": "AM",
		"code": "AM",
		"name": "Armenia",
	},
	"AA": {
		"iso_code": "AW",
		"code": "AA",
		"name": "Aruba",
	},
	"AT": {
		"iso_code": "AT",
		"code": "AT",
		"name": "Ashmore and Cartier Islands",
	},
	"AU": {
		"iso_code": "AT",
		"code": "AU",
		"name": "Austria",
		"currency": "EUR",
	},
	"AJ": {
		"iso_code": "AZ",
		"code": "AJ",
		"name": "Azerbaijan",
	},
	"BF": {
		"iso_code": "BS",
		"code": "BF",
		"name": "Bahamas",
	},
	"BA": {
		"iso_code": "BH",
		"code": "BA",
		"name": "Bahrain",
	},
	"BG": {
		"iso_code": "BD",
		"code": "BG",
		"name": "Bangladesh",
	},
	"BB": {
		"iso_code": "BB",
		"code": "BB",
		"name": "Barbados",
	},
	"BO": {
		"iso_code": "BY",
		"code": "BO",
		"name": "Belarus",
	},
	"BE": {
		"iso_code": "BE",
		"code": "BE",
		"name": "Belgium",
		"currency": "EUR",
	},
	"BH": {
		"iso_code": "BZ",
		"code": "BH",
		"name": "Belize",
	},
	"BN": {
		"iso_code": "BJ",
		"code": "BN",
		"name": "Benin",
	},
	"BD": {
		"iso_code": "BM",
		"code": "BD",
		"name": "Bermuda",
	},
	"BT": {
		"iso_code": "BT",
		"code": "BT",
		"name": "Bhutan",
	},
	"BL": {
		"iso_code": "BO",
		"code": "BL",
		"name": "Bolivia",
	},
	"BK": {
		"iso_code": "BA",
		"code": "BK",
		"name": "Bosnia and Herzegovina",
	},
	"BC": {
		"iso_code": "BW",
		"code": "BC",
		"name": "Botswana",
	},
	"BR": {
		"iso_code": "BR",
		"code": "BR",
		"name": "Brazil",
		"currency": "BRL",
	},
	"VI": {
		"iso_code": "VG",
		"code": "VI",
		"name": "British Virgin Islands",
	},
	"BX": {
		"iso_code": "BN",
		"code": "BX",
		"name": "Brunei",
	},
	"BU": {
		"iso_code": "BG",
		"code": "BU",
		"name": "Bulgaria",
	},
	"UV": {
		"iso_code": "BF",
		"code": "UV",
		"name": "Burkina Faso",
	},
	"BM": {
		"iso_code": "MM",
		"code": "BM",
		"name": "Burma",
	},
	"BY": {
		"iso_code": "BI",
		"code": "BY",
		"name": "Burundi",
	},
	"CB": {
		"iso_code": "KH",
		"code": "CB",
		"name": "Cambodia",
	},
	"CM": {
		"iso_code": "CM",
		"code": "CM",
		"name": "Cameroon",
	},
	"CV": {
		"iso_code": "CV",
		"code": "CV",
		"name": "Cape Verde",
	},
	"CJ": {
		"iso_code": "KY",
		"code": "CJ",
		"name": "Cayman Islands",
	},
	"CT": {
		"iso_code": "CF",
		"code": "CT",
		"name": "Central African Republic",
	},
	"CD": {
		"iso_code": "TD",
		"code": "CD",
		"name": "Chad",
	},
	"CI": {
		"iso_code": "CL",
		"code": "CI",
		"name": "Chile",
	},
	"CH": {
		"iso_code": "CN",
		"code": "CH",
		"name": "China",
		"currency": "CNY",
	},
	"KT": {
		"iso_code": "CX",
		"code": "KT",
		"name": "Christmas Island",
	},
	"CO": {
		"iso_code": "CO",
		"code": "CO",
		"name": "Colombia",
	},
	"CN": {
		"iso_code": "KM",
		"code": "CN",
		"name": "Comoros",
	},
	"CF": {
		"iso_code": "CG",
		"code": "CF",
		"name": "Congo",
	},
	"CW": {
		"iso_code": "CK",
		"code": "CW",
		"name": "Cook Islands",
	},
	"CR": {
		"iso_code": "CR",
		"code": "CR",
		"name": "Coral Sea Islands",
	},
	"CS": {
		"iso_code": "CR",
		"code": "CS",
		"name": "Costa Rica",
	},
	"IV": {
		"iso_code": "CI",
		"code": "IV",
		"name": "Cote d'Ivoire",
	},
	"HR": {
		"iso_code": "HR",
		"code": "HR",
		"name": "Croatia",
	},

	/*
	"CU": {
		"iso_code": "CU",
		"code": "CU",
		"name": "Cuba",
	},
	*/
	"CY": {
		"iso_code": "CY",
		"code": "CY",
		"name": "Cyprus",
		"currency": "EUR",
	},
	"EZ": {
		"iso_code": "CZ",
		"code": "EZ",
		"name": "Czech Republic",
	},
	"CG": {
		"iso_code": "CD",
		"code": "CG",
		"name": "Democratice Republic of the Congo",
	},
	"DA": {
		"iso_code": "DK",
		"code": "DA",
		"name": "Denmark",
		"currency": "DKK",
	},
	"DJ": {
		"iso_code": "DJ",
		"code": "DJ",
		"name": "Djibouti",
	},
	"DO": {
		"iso_code": "DM",
		"code": "DO",
		"name": "Dominica",
	},
	"DR": {
		"iso_code": "DO",
		"code": "DR",
		"name": "Dominican Republic",
	},
	"TT": {
		"iso_code": "TL",
		"code": "TT",
		"name": "East Timor",
	},
	"EC": {
		"iso_code": "EC",
		"code": "EC",
		"name": "Ecuador",
	},
	"EG": {
		"iso_code": "EG",
		"code": "EG",
		"name": "Egypt",
	},
	"ES": {
		"iso_code": "SV",
		"code": "ES",
		"name": "El Salvador",
	},
	"EK": {
		"iso_code": "GQ",
		"code": "EK",
		"name": "Equatorial Guinea",
	},
	"ER": {
		"iso_code": "ER",
		"code": "ER",
		"name": "Eritrea",
	},
	"EN": {
		"iso_code": "EE",
		"code": "EN",
		"name": "Estonia",
		"currency": "EUR",
	},
	"ET": {
		"iso_code": "ET",
		"code": "ET",
		"name": "Ethiopia",
	},
	"EU": {
		"iso_code": "EU",
		"code": "EU",
		"name": "Europa Island",
	},
	"FK": {
		"iso_code": "FK",
		"code": "FK",
		"name": "Falkland Islands",
	},
	"FO": {
		"iso_code": "FO",
		"code": "FO",
		"name": "Faroe Islands",
	},
	"FJ": {
		"iso_code": "FJ",
		"code": "FJ",
		"name": "Fiji",
	},
	"FR": {
		"iso_code": "FR",
		"code": "FR",
		"name": "France",
		"currency": "EUR",
	},
	"FG": {
		"iso_code": "GF",
		"code": "FG",
		"name": "French Guiana",
	},
	"FP": {
		"iso_code": "PF",
		"code": "FP",
		"name": "French Polynesia",
	},
	"FS": {
		"iso_code": "TF",
		"code": "FS",
		"name": "French Southern and Antarctic Lands",
	},
	"GB": {
		"iso_code": "GA",
		"code": "GB",
		"name": "Gabon",
	},
	"GA": {
		"iso_code": "GM",
		"code": "GA",
		"name": "Gambia",
	},
	"GZ": {
		"iso_code": "GZ",
		"code": "GZ",
		"name": "Gaza Strip",
	},
	"GG": {
		"iso_code": "GE",
		"code": "GG",
		"name": "Georgia",
	},
	"GM": {
		"iso_code": "DE",
		"code": "GM",
		"name": "Germany",
		"currency": "EUR",
	},
	"GH": {
		"iso_code": "GH",
		"code": "GH",
		"name": "Ghana",
	},
	"GI": {
		"iso_code": "GI",
		"code": "GI",
		"name": "Gibraltar",
	},
	"GO": {
		"iso_code": "GO",
		"code": "GO",
		"name": "Glorioso Islands",
	},
	"GR": {
		"iso_code": "GR",
		"code": "GR",
		"name": "Greece",
		"currency": "EUR",
	},
	"GL": {
		"iso_code": "GL",
		"code": "GL",
		"name": "Greenland",
		"currency": "DKK",
	},
	"GJ": {
		"iso_code": "GD",
		"code": "GJ",
		"name": "Grenada",
	},
	"GP": {
		"iso_code": "GP",
		"code": "GP",
		"name": "Guadeloupe",
	},
	"GT": {
		"iso_code": "GT",
		"code": "GT",
		"name": "Guatemala",
	},
	"GK": {
		"iso_code": "GG",
		"code": "GK",
		"name": "Guernsey",
	},
	"GV": {
		"iso_code": "GN",
		"code": "GV",
		"name": "Guinea",
	},
	"PU": {
		"iso_code": "GW",
		"code": "PU",
		"name": "Guinea-Bissau",
	},
	"GY": {
		"iso_code": "GY",
		"code": "GY",
		"name": "Guyana",
	},
	"HA": {
		"iso_code": "HT",
		"code": "HA",
		"name": "Haiti",
	},
	"HM": {
		"iso_code": "HM",
		"code": "HM",
		"name": "Heard Island and McDonald Islands",
	},
	"HO": {
		"iso_code": "HN",
		"code": "HO",
		"name": "Honduras",
	},
	"HK": {
		"iso_code": "HK",
		"code": "HK",
		"name": "Hong Kong",
		"currency": "HKD",
	},
	"HU": {
		"iso_code": "HU",
		"code": "HU",
		"name": "Hungary",
	},
	"IC": {
		"iso_code": "IS",
		"code": "IC",
		"name": "Iceland",
	},
	"IN": {
		"iso_code": "IN",
		"code": "IN",
		"name": "India",
		"currency": "INR",
	},
	"ID": {
		"iso_code": "ID",
		"code": "ID",
		"name": "Indonesia",
		"currency": "IDR",
	},

	/*
	"IR": {
		"iso_code": "IR",
		"code": "IR",
		"name": "Iran",
	},
	*/
	"IZ": {
		"iso_code": "IQ",
		"code": "IZ",
		"name": "Iraq",
	},
	"IM": {
		"iso_code": "IM",
		"code": "IM",
		"name": "Isle of Man",
	},
	"IS": {
		"iso_code": "IL",
		"code": "IS",
		"name": "Israel",
		"currency": "ILS",
	},
	"IT": {
		"iso_code": "IT",
		"code": "IT",
		"name": "Italy",
		"currency": "EUR",
	},
	"JM": {
		"iso_code": "JM",
		"code": "JM",
		"name": "Jamaica",
	},
	"JN": {
		"iso_code": "JN",
		"code": "JN",
		"name": "Jan Mayen",
	},
	"JA": {
		"iso_code": "JP",
		"code": "JA",
		"name": "Japan",
		"currency": "JPY",
	},
	"JE": {
		"iso_code": "JE",
		"code": "JE",
		"name": "Jersey",
	},
	"JO": {
		"iso_code": "JO",
		"code": "JO",
		"name": "Jordan",
	},
	"JU": {
		"iso_code": "JU",
		"code": "JU",
		"name": "Juan de Nova Island",
	},
	"KZ": {
		"iso_code": "KZ",
		"code": "KZ",
		"name": "Kazakhstan",
	},
	"KE": {
		"iso_code": "KE",
		"code": "KE",
		"name": "Kenya",
	},
	"KR": {
		"iso_code": "KI",
		"code": "KR",
		"name": "Kiribati",
	},
	"KU": {
		"iso_code": "KW",
		"code": "KU",
		"name": "Kuwait",
	},
	"KG": {
		"iso_code": "KG",
		"code": "KG",
		"name": "Kyrgyzstan",
	},
	"LA": {
		"iso_code": "LA",
		"code": "LA",
		"name": "Laos",
	},
	"LG": {
		"iso_code": "LV",
		"code": "LG",
		"name": "Latvia",
		"currency": "EUR",
	},
	"LE": {
		"iso_code": "LB",
		"code": "LE",
		"name": "Lebanon",
	},
	"LT": {
		"iso_code": "LS",
		"code": "LT",
		"name": "Lesotho",
	},
	"LI": {
		"iso_code": "LR",
		"code": "LI",
		"name": "Liberia",
	},
	"LY": {
		"iso_code": "LY",
		"code": "LY",
		"name": "Libya",
	},
	"LS": {
		"iso_code": "LI",
		"code": "LS",
		"name": "Liechtenstein",
	},
	"LH": {
		"iso_code": "LT",
		"code": "LH",
		"name": "Lithuania",
	},
	"LU": {
		"iso_code": "LU",
		"code": "LU",
		"name": "Luxembourg",
		"currency": "EUR",
	},
	"MC": {
		"iso_code": "MO",
		"code": "MC",
		"name": "Macau",
	},
	"MK": {
		"iso_code": "MK",
		"code": "MK",
		"name": "Macedonia",
	},
	"MA": {
		"iso_code": "MG",
		"code": "MA",
		"name": "Madagascar",
	},
	"MI": {
		"iso_code": "MW",
		"code": "MI",
		"name": "Malawi",
	},
	"MY": {
		"iso_code": "MY",
		"code": "MY",
		"name": "Malaysia",
	},
	"MV": {
		"iso_code": "MV",
		"code": "MV",
		"name": "Maldives",
	},
	"ML": {
		"iso_code": "ML",
		"code": "ML",
		"name": "Mali",
	},
	"MT": {
		"iso_code": "MT",
		"code": "MT",
		"name": "Malta",
		"currency": "EUR",
	},
	"RM": {
		"iso_code": "MH",
		"code": "RM",
		"name": "Marshall Islands",
	},
	"MB": {
		"iso_code": "MQ",
		"code": "MB",
		"name": "Martinique",
	},
	"MR": {
		"iso_code": "MR",
		"code": "MR",
		"name": "Mauritania",
	},
	"MP": {
		"iso_code": "MU",
		"code": "MP",
		"name": "Mauritius",
	},
	"MF": {
		"iso_code": "YT",
		"code": "MF",
		"name": "Mayotte",
	},
	"MX": {
		"iso_code": "MX",
		"code": "MX",
		"name": "Mexico",
		"currency": "MXN",
	},
	"FM": {
		"iso_code": "FM",
		"code": "FM",
		"name": "Micronesia Federal States",
	},
	"MD": {
		"iso_code": "MD",
		"code": "MD",
		"name": "Moldova",
	},
	"MN": {
		"iso_code": "MC",
		"code": "MN",
		"name": "Monaco",
	},
	"MG": {
		"iso_code": "MN",
		"code": "MG",
		"name": "Mongolia",
	},
	"MJ": {
		"iso_code": "ME",
		"code": "MJ",
		"name": "Montenegro",
	},
	"MH": {
		"iso_code": "MS",
		"code": "MH",
		"name": "Montserrat",
	},
	"MO": {
		"iso_code": "MA",
		"code": "MO",
		"name": "Morocco",
	},
	"MZ": {
		"iso_code": "MZ",
		"code": "MZ",
		"name": "Mozambique",
	},
	"WA": {
		"iso_code": "NA",
		"code": "WA",
		"name": "Namibia",
	},
	"NR": {
		"iso_code": "NR",
		"code": "NR",
		"name": "Nauru",
	},
	"NP": {
		"iso_code": "NP",
		"code": "NP",
		"name": "Nepal",
	},
	"NL": {
		"iso_code": "NL",
		"code": "NL",
		"name": "Netherlands",
		"currency": "EUR",
	},
	"NT": {
		"iso_code": "AN",
		"code": "NT",
		"name": "Netherlands Antilles",
	},
	"NC": {
		"iso_code": "NC",
		"code": "NC",
		"name": "New Caledonia",
	},
	"NU": {
		"iso_code": "NI",
		"code": "NU",
		"name": "Nicaragua",
	},
	"NG": {
		"iso_code": "NE",
		"code": "NG",
		"name": "Niger",
	},
	"NI": {
		"iso_code": "NG",
		"code": "NI",
		"name": "Nigeria",
	},
	"NE": {
		"iso_code": "NU",
		"code": "NE",
		"name": "Niue",
	},
	"NM": {
		"iso_code": "NM",
		"code": "NM",
		"name": "No Man's Land",
	},
	"NF": {
		"iso_code": "NF",
		"code": "NF",
		"name": "Norfolk Island",
	},

	/*
	"KN": {
		"iso_code": "KP",
		"code": "KN",
		"name": "North Korea",
	},
	*/
	"NO": {
		"iso_code": "NO",
		"code": "NO",
		"name": "Norway",
		"currency": "NOK",
	},
	"OS": {
		"iso_code": "OS",
		"code": "OS",
		"name": "Oceans",
	},
	"MU": {
		"iso_code": "OM",
		"code": "MU",
		"name": "Oman",
	},
	"PK": {
		"iso_code": "PK",
		"code": "PK",
		"name": "Pakistan",
	},
	"PS": {
		"iso_code": "PW",
		"code": "PS",
		"name": "Palau",
	},
	"PM": {
		"iso_code": "PA",
		"code": "PM",
		"name": "Panama",
	},
	"PP": {
		"iso_code": "PG",
		"code": "PP",
		"name": "Papua New Guinea",
	},
	"PA": {
		"iso_code": "PY",
		"code": "PA",
		"name": "Paraguay",
	},
	"PE": {
		"iso_code": "PE",
		"code": "PE",
		"name": "Peru",
	},
	"PC": {
		"iso_code": "PN",
		"code": "PC",
		"name": "Pitcairn Islands",
	},
	"PL": {
		"iso_code": "PL",
		"code": "PL",
		"name": "Poland",
	},
	"PO": {
		"iso_code": "PT",
		"code": "PO",
		"name": "Portugal",
		"currency": "EUR",
	},
	"QA": {
		"iso_code": "QA",
		"code": "QA",
		"name": "Qatar",
	},
	"RE": {
		"iso_code": "RE",
		"code": "RE",
		"name": "Reunion",
	},
	"RO": {
		"iso_code": "RO",
		"code": "RO",
		"name": "Romania",
	},
	"RS": {
		"iso_code": "RU",
		"code": "RS",
		"name": "Russia",
		"currency": "RUB",
	},
	"RW": {
		"iso_code": "RW",
		"code": "RW",
		"name": "Rwanda",
	},
	"SH": {
		"iso_code": "SH",
		"code": "SH",
		"name": "Saint Helena",
	},
	"SC": {
		"iso_code": "KN",
		"code": "SC",
		"name": "Saint Kitts and Nevis",
	},
	"ST": {
		"iso_code": "LC",
		"code": "ST",
		"name": "Saint Lucia",
	},
	"SB": {
		"iso_code": "PM",
		"code": "SB",
		"name": "Saint Pierre and Miquelon",
	},
	"VC": {
		"iso_code": "VC",
		"code": "VC",
		"name": "Saint Vincent and the Grenadines",
	},
	"WS": {
		"iso_code": "WS",
		"code": "WS",
		"name": "Samoa",
	},
	"SM": {
		"iso_code": "SM",
		"code": "SM",
		"name": "San Marino",
	},
	"TP": {
		"iso_code": "ST",
		"code": "TP",
		"name": "Sao Tome and Principe",
	},
	"SA": {
		"iso_code": "SA",
		"code": "SA",
		"name": "Saudi Arabia",
		"currency": "SAR",
	},
	"SG": {
		"iso_code": "SN",
		"code": "SG",
		"name": "Senegal",
	},
	"RB": {
		"iso_code": "RS",
		"code": "RB",
		"name": "Serbia",
	},
	"SE": {
		"iso_code": "SC",
		"code": "SE",
		"name": "Seychelles",
	},
	"SL": {
		"iso_code": "SL",
		"code": "SL",
		"name": "Sierra Leone",
	},
	"LO": {
		"iso_code": "SK",
		"code": "LO",
		"name": "Slovakia",
		"currency": "EUR",
	},
	"SI": {
		"iso_code": "SI",
		"code": "SI",
		"name": "Slovenia",
		"currency": "EUR",
	},
	"BP": {
		"iso_code": "SB",
		"code": "BP",
		"name": "Solomon Islands",
	},
	"SO": {
		"iso_code": "SO",
		"code": "SO",
		"name": "Somalia",
	},
	"SF": {
		"iso_code": "ZA",
		"code": "SF",
		"name": "South Africa",
		"currency": "ZAR",
	},
	"SX": {
		"iso_code": "GS",
		"code": "SX",
		"name": "South Georgia and the South Sandwich Islands",
	},
	"KS": {
		"iso_code": "KR",
		"code": "KS",
		"name": "South Korea",
	},
	"SP": {
		"iso_code": "ES",
		"code": "SP",
		"name": "Spain",
		"currency": "EUR",
	},
	"PG": {
		"iso_code": "PG",
		"code": "PG",
		"name": "Spratly Islands",
	},
	"CE": {
		"iso_code": "LK",
		"code": "CE",
		"name": "Sri Lanka",
	},

	/*
	"SU": {
		"iso_code": "SD",
		"code": "SU",
		"name": "Sudan",
	},
	*/
	"NS": {
		"iso_code": "SR",
		"code": "NS",
		"name": "Suriname",
	},
	"SV": {
		"iso_code": "SJ",
		"code": "SV",
		"name": "Svalbard",
	},
	"WZ": {
		"iso_code": "SZ",
		"code": "WZ",
		"name": "Swaziland",
	},
	"SZ": {
		"iso_code": "CH",
		"code": "SZ",
		"name": "Switzerland",
		"currency": "CHF",
	},

	/*
	"SY": {
		"iso_code": "SY",
		"code": "SY",
		"name": "Syria",
	},
	*/
	"TW": {
		"iso_code": "TW",
		"code": "TW",
		"name": "Taiwan",
		"currency": "TWD",
	},
	"TI": {
		"iso_code": "TJ",
		"code": "TI",
		"name": "Tajikistan",
	},
	"TZ": {
		"iso_code": "TZ",
		"code": "TZ",
		"name": "Tanzania",
	},
	"TH": {
		"iso_code": "TH",
		"code": "TH",
		"name": "Thailand",
	},
	"TO": {
		"iso_code": "TG",
		"code": "TO",
		"name": "Togo",
	},
	"TL": {
		"iso_code": "TK",
		"code": "TL",
		"name": "Tokelau",
	},
	"TN": {
		"iso_code": "TO",
		"code": "TN",
		"name": "Tonga",
	},
	"TD": {
		"iso_code": "TT",
		"code": "TD",
		"name": "Trinidad and Tobago",
	},
	"TS": {
		"iso_code": "TN",
		"code": "TS",
		"name": "Tunisia",
	},
	"TU": {
		"iso_code": "TR",
		"code": "TU",
		"name": "Turkey",
		"currency": "TRY",
	},
	"TX": {
		"iso_code": "TM",
		"code": "TX",
		"name": "Turkmenistan",
	},
	"TK": {
		"iso_code": "TC",
		"code": "TK",
		"name": "Turks and Caicos Islands",
	},
	"TV": {
		"iso_code": "TV",
		"code": "TV",
		"name": "Tuvalu",
	},
	"UG": {
		"iso_code": "UG",
		"code": "UG",
		"name": "Uganda",
	},
	"UP": {
		"iso_code": "UA",
		"code": "UP",
		"name": "Ukraine",
	},
	"AE": {
		"iso_code": "AE",
		"code": "AE",
		"name": "United Arab Emirates",
		"currency": "AED",
	},
	"UY": {
		"iso_code": "UY",
		"code": "UY",
		"name": "Uruguay",
	},
	"UZ": {
		"iso_code": "UZ",
		"code": "UZ",
		"name": "Uzbekistan",
	},
	"NH": {
		"iso_code": "VU",
		"code": "NH",
		"name": "Vanuatu",
	},
	"VE": {
		"iso_code": "VE",
		"code": "VE",
		"name": "Venezuela",
	},
	"VM": {
		"iso_code": "VN",
		"code": "VM",
		"name": "Vietnam",
	},
	"WF": {
		"iso_code": "WF",
		"code": "WF",
		"name": "Wallis and Futuna",
	},
	"WE": {
		"iso_code": "PS",
		"code": "WE",
		"name": "West Bank",
	},
	"WI": {
		"iso_code": "EH",
		"code": "WI",
		"name": "Western Sahara",
	},
	"YM": {
		"iso_code": "YE",
		"code": "YM",
		"name": "Yemen",
	},
	"ZA": {
		"iso_code": "ZM",
		"code": "ZA",
		"name": "Zambia",
	},
	"ZI": {
		"iso_code": "ZW",
		"code": "ZI",
		"name": "Zimbabwe",
	},
};

export const GET_COUNTRY_BY_CODE = (code) => {
	if (COUNTRIES_BY_CODE[code]) {
		return COUNTRIES_BY_CODE[code].name;
	} else {
		return "";
	}
};



// WEBPACK FOOTER //
// ./src/shared/dictionaries/countries.js